module.exports = __webpack_public_path__ + "static/media/heart.c5c7b1ca.svg";